import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import {
  BUDGET_BASE_URL,
  DASHBOARD_URL,
  HOME_URL,
  SERVICE_REQUEST_BASE_URL
} from "@core/constants";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { KeycloakHelperService } from "./keycloak.helper.service";
import { NavigationService } from "./navigation.service";
import { FranchiseService } from "./franchise.service";

@Injectable({
  providedIn: "root"
})
export class RedirectService {
  constructor(
    private router: Router,
    private keycloakHelperService: KeycloakHelperService,
    private navigationService: NavigationService,
    private franchiseService: FranchiseService
  ) {}

  redirectToServiceRequest(): void {
    // Necessary when the user is already on the service request url.
    // The user will be redirected to another url and
    // then back to the service requests url.
    void this.router
      .navigateByUrl("/", {
        skipLocationChange: true
      })
      .then(() => this.router.navigateByUrl(SERVICE_REQUEST_BASE_URL));
  }

  redirectToCarworkshopContacts(carWorkshopId: number) {
    const url = `car-workshops/edit/${carWorkshopId}?scrollTo=contacts-id`;
    this.router.navigateByUrl(`${url}`);
  }

  getHomeUrl$(): Observable<string> {
    if (this.keycloakHelperService.isBackofficeExternalLogged()) {
      return of(SERVICE_REQUEST_BASE_URL);
    }

    return this.franchiseService.isDriveBFranchiseUser().pipe(
      map((isDriveBFranchiseUser) => {
        if (
          this.keycloakHelperService.isCarWorkshopLogged() ||
          !isDriveBFranchiseUser
        ) {
          return DASHBOARD_URL;
        }

        return HOME_URL;
      })
    );
  }

  getServiceRequestUrl(): string {
    return SERVICE_REQUEST_BASE_URL;
  }

  getServiceRequestDetailsUrl(id: number): string {
    return `${SERVICE_REQUEST_BASE_URL}/${id}/details`;
  }

  getBudgetDetailsUrl(serviceReqId: number, budgetId: number): string {
    const url = this.getServiceRequestDetailsUrl(serviceReqId);
    return `${url}/${budgetId}/budget`;
  }

  getEvaluationBudgetCounterproposal(budgetId: number): string {
    return `${BUDGET_BASE_URL}/${budgetId}/evaluation-budget-counterproposal`;
  }

  getBackUrl(serviceReqId: number): string {
    const history = this.navigationService.getHistory();

    if (history.length === 1) {
      return this.getServiceRequestDetailsUrl(serviceReqId);
    }

    let backUrl = history[history.length - 2];
    backUrl = backUrl.startsWith("/") ? backUrl.substring(1) : backUrl;
    return backUrl;
  }
}
